import { RouterView } from "vue-router";

export const festivalsRoute = {
  path: ":menu/festivals",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/festivals/list/index.vue"),
    },
  ],
};
